import React from 'react';

interface SatisfactionHeartProps {
  score: number;
  maxScore?: number;
  size?: number;
}

export const SatisfactionHeart: React.FC<SatisfactionHeartProps> = ({ 
  score, 
  maxScore = 7, 
  size = 32 
}) => {
  // Calculate fill percentage (0 to 1)
  const fillPercentage = Math.min(Math.max(score / maxScore, 0), 1);
  
  // Generate gradient ID unique to this instance
  const gradientId = `heart-gradient-${Math.random().toString(36).substr(2, 9)}`;
  
  // Calculate color based on score
  const getColor = () => {
    if (fillPercentage >= 0.8) return '#10B981'; // success-500 (green)
    if (fillPercentage >= 0.6) return '#F59E0B'; // warning-500 (orange) 
    if (fillPercentage >= 0.4) return '#EF4444'; // error-500 (red)
    return '#6B7280'; // gray-500 for very low scores
  };

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className="overflow-visible">
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset={`${(1 - fillPercentage) * 100}%`} stopColor="transparent" />
          <stop offset={`${(1 - fillPercentage) * 100}%`} stopColor={getColor()} />
          <stop offset="100%" stopColor={getColor()} />
        </linearGradient>
      </defs>
      
      {/* Heart outline */}
      <path
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
        fill="none"
        stroke="#E5E7EB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Filled heart */}
      <path
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
};